<template>
    <div style=" display: flex; gap: 8px;">
        <span :style="{marginTop: marginTop}" class="deco_circle"></span>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'CircleText',
    props: {
        marginTop: {
            type: String,
            default: '7px'
        }
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

.deco_circle {
    width: 4px;
    height: 4px;
    background-color: #606060;
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
    margin-top: 7px;
}
</style>